import { render, staticRenderFns } from "./CalendarRegistration.vue?vue&type=template&id=6942dbfa&scoped=true&"
import script from "./CalendarRegistration.vue?vue&type=script&lang=js&"
export * from "./CalendarRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CalendarRegistration.vue?vue&type=style&index=0&id=6942dbfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6942dbfa",
  null
  
)

export default component.exports